<app-truck-sidebar></app-truck-sidebar>
<div class="truck-owner-details">
  <div class="row">
    <div class="col-md-6"></div>

    <div class="col-md-12">
      <mat-card>
        <div class="trip-acoordion">
          <a
            [ngClass]="{ active: orderType == '-1' }"
            (click)="getTripsList('-1')"
            >All Trip</a
          >
          <a
            [ngClass]="{ active: orderType == 'liveTrips' }"
            (click)="getTripsList('liveTrips')"
            >Live Trips</a
          >
          <a
            [ngClass]="{ active: orderType == 'completed' }"
            (click)="getTripsList('completed')"
            >Completed</a
          >
          <a
            [ngClass]="{ active: orderType == 'cancelled' }"
            (click)="getTripsList('cancelled')"
            >Cancelled</a
          >
        </div>
      </mat-card>
    </div>
  </div>
  <div class="truck-owner-items" *ngIf="order_track">
    <div class="to_container">
      <div [class.spinner]="loading"></div>
      <div class="row" *ngIf="!ordersArray?.length && !loading">
        <h4 class="error_msg">No Records Found.</h4>
      </div>
      <div class="row" *ngIf="ordersArray.length && !loading">
        <div class="col-sm-6" *ngFor="let item of ordersArray; let i = index">
          <mat-card class="truck-list">
            <div class="row">
              <div class="col-md-6">
                <div class="order">
                  <div class="left">
                    <img
                      (click)="viewTrips(item)"
                      src="../../../assets/img/trip.svg"
                      class="trip"
                      matTooltip="View Details"
                      matTooltipPosition="above"
                      style="cursor: pointer;"
                    />
                  </div>
                  <div class="right">
                    <p>
                      <span 
                        class="trip_id" 
                        (click)="viewTrips(item)"
                        matTooltip="View Details"
                        matTooltipPosition="above"
                        style="cursor: pointer;"
                      >{{ item.trip_id }}</span> <br />
                      {{ item.pickup_date | date : "dd-MM-yyyy" }}
                      <br />
                      {{ item.truckInfo[0]?.truck_number }}
                    </p>
                  </div>
                </div>
                <div class="content">
                  <!-- <img src="../../../assets/img/location-payment.svg" alt="" /> -->
                  <img
                    [src]="item.stops?.length > 0
                            ? '../../../assets/img/location-payment-stop.svg'
                            : '../../../assets/img/location-payment.svg'"
                    [matTooltip]="item.stops?.length > 0 ? ('Stops: ' + item.stops.length) : ''"
                    [matTooltipDisabled]="!(item.stops?.length > 0)"
                    matTooltipPosition="right"
                    alt=""
                  />
                  <div class="right-img">
                    <p>
                      {{ item.pickup_details.from_city_name }}
                      <span>{{
                        getAddressLine(item.pickup_details.from_area_name)
                      }}</span>
                    </p>
                    <p class="button cancel-btn">{{ item.trip_status }}</p>
                    <p>
                      {{ item.dropoff_details.to_city_name }}
                      <span>{{ item.dropoff_details.to_area_name }}</span>
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-6 second-col">
                <div class="item-container">
                  <div class="item-left" *ngIf="item.userInfo.user_type == 'corporate'" style="color: #888;">
                    Credit Trip 
                    <span *ngIf="item.isEstimatedPrice" style="color: #f0501d; font-size: 11px; margin-left: 2px;">(Estimated)</span>
                  </div>
                  <div class="item-right color-1">
                    ₹ {{ item.finalFareAfterDeductions | number : "1.2-2" }}
                  </div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="arrow"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="m8.25 4.5 7.5 7.5-7.5 7.5"
                    />
                  </svg>
                </div>
                <div class="item-container">
                  <div class="item-left">Paid</div>
                  <div class="item-right color-2">
                    ₹ {{ item.amountPaid | number : "1.2-2" }}
                  </div>
                </div>
                <div class="item-container">
                  <div class="item-left"> Balance</div>
                  <div class="item-right color-3">
                    ₹ {{ item.balanceAmnt | number: '1.2-2' }} /-
                  </div>
                </div>
              </div>
              <div
                *ngIf="
                  item.workOrderInfoInfo[0]?.pay_as_load_quantity ===
                  'unloading_point'
                "
              >
                <h6 style="color: red; font-size: revert">
                  Note:This is an Approximate price. Actual price may vary based
                  on unloading quantity
                </h6>
              </div>
              <div class="row mt-2">
                <div class="col-md-12">
                  <div class="track" *ngIf="item.trip_status === 'tripstarted' || item.trip_status === 'inprogress'">
                    <div
                      (click)="liveTrack(item._id)"
                      style="cursor:pointer; background-color: #0d6efd; color: white; text-align: center; padding: 5px; border-radius: 5px;"
                    >
                      <i class="fa fa-map-marker" style="margin-right: 5px;"></i> Track
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
    <div *ngIf="last_page && last_page > 1" class="pagination">
      <button class="btn" [disabled]="fetch_page == 1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="btn--icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
          (click)="pagination('-1')"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>
      <button class="btn" [disabled]="fetch_page == 1">
        <img
          src="../../../assets/img/pagination-left.svg"
          (click)="pagination('first')"
          alt=""
          class="btn--icon"
        />
      </button>
      <div class="pages">
        <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
      </div>
      <button class="btn" [disabled]="last_page == fetch_page">
        <img
          src="../../../assets/img/pagination-right.svg"
          (click)="pagination('last')"
          alt=""
          class="btn--icon"
        />
      </button>
      <button class="btn" [disabled]="last_page == fetch_page">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="btn--icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
          (click)="pagination('1')"
        >
          <path
            stroke-linecap=" round"
            stroke-linejoin="round"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>
    </div>
  </div>

  <div class="truck-owner-items" *ngIf="!order_track" style="background: #fff; padding: 20px; border-radius: 12px; box-shadow: 0 4px 15px rgba(0,0,0,0.05);">
    
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h3 style="margin: 0; font-weight: 600; color: #333; font-size: 1.25rem;">
        <i class="fa fa-map-marker text-primary" style="margin-right: 8px; color: #f58634 !important;"></i> Live Tracking
      </h3>
      <button
        type="button"
        class="btn btn-outline-danger close-tracking"
        (click)="closeTracking()"
        style="border-radius: 20px; padding: 6px 16px; font-weight: 500;"
      >
        <i class="fa fa-times" style="margin-right: 5px;"></i> Close
      </button>
    </div>
    
    <div class="loader-container" *ngIf="isLoading">
      <div class="circle-dot-loader">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
    </div>

    <!-- Map Container -->
    <div style="border-radius: 12px; overflow: hidden; box-shadow: 0 4px 15px rgba(0,0,0,0.08); margin-bottom: 20px; min-height: 400px; background-color: #f8f9fa;">
      <div id="map-container" style="width: 100%; height: 100%; min-height: 400px; display: block;"></div>
    </div>

    <!-- View Full Tracking Action -->
    <div class="mb-4" *ngIf="!showFullTracking">
      <button
        type="button"
        class="btn w-100 d-flex justify-content-center align-items-center"
        style="background: linear-gradient(135deg, #f58634 0%, #ff6b00 100%); border: none; border-radius: 8px; padding: 12px; font-weight: 600; color: white; box-shadow: 0 4px 10px rgba(245, 134, 52, 0.3); transition: transform 0.2s;"
        (click)="viewFullTracking()"
        [disabled]="isFullTrackingLoading"
      >
        <i class="fa fa-map-signs" style="margin-right: 8px; font-size: 1.2rem;"></i>
        {{ isFullTrackingLoading ? 'Loading Full Route...' : 'View Full Tracking Route' }}
      </button>
    </div>

    <!-- Trip Status Details -->
    <div class="trip_status" style="background: #f8f9fa; border-radius: 12px; padding: 20px; border: 1px solid #eee;">
      <h4 style="font-size: 1.1rem; margin-bottom: 15px; color: #555; border-bottom: 1px solid #ddd; padding-bottom: 8px;">Trip Information</h4>
      <div class="row">
        <div class="col-md-6">
          <ul class="tripDetails" style="list-style: none; padding: 0; margin: 0;">
            <li style="margin-bottom: 10px;"><strong style="color: #666; font-weight: 600; display: inline-block; width: 140px;">Trip ID:</strong> <span style="font-weight: 500;">{{ trackArray?.trip_id }}</span></li>
            <li style="margin-bottom: 10px;">
              <strong style="color: #666; font-weight: 600; display: inline-block; width: 140px;">Truck Number:</strong>
              <span style="font-weight: 500; background: #e3f2fd; color: #0d6efd; padding: 2px 8px; border-radius: 4px;">{{ trackArray?.truckInfo?.truck_number || data?.vehicleNumber }}</span>
            </li>
            <li style="margin-bottom: 10px; display: flex; align-items: flex-start;">
              <strong style="color: #666; font-weight: 600; display: inline-block; width: 140px; flex-shrink: 0;">Location:</strong>
              <span>{{ data?.address }}</span>
            </li>
            <li style="margin-bottom: 0;">
              <strong style="color: #666; font-weight: 600; display: inline-block; width: 140px;">Last Updated:</strong>
              <span style="color: #28a745; font-weight: 500;">{{ (data?.endTrackDateTime || data?.trackDateTime) ? ((data?.endTrackDateTime || data?.trackDateTime) | date : "dd MMMM yyyy, hh:mm:ss a") : '--' }}</span>
            </li>
          </ul>
        </div>
        <div class="col-md-6 mt-3 mt-md-0">
          <ul class="tripDetails" style="list-style: none; padding: 0; margin: 0;">
            <li style="margin-bottom: 10px;">
              <strong style="color: #666; font-weight: 600; display: inline-block; width: 160px;">Truck Owner:</strong>
              <span style="font-weight: 500;">{{ trackArray?.truckOwnerInfo?.username || trackArray?.truckownerDetails?.username }}</span>
            </li>
            <li style="margin-bottom: 10px;">
              <strong style="color: #666; font-weight: 600; display: inline-block; width: 160px;">Contact:</strong>
              <span style="font-weight: 500;"><i class="fa fa-phone" style="color: #28a745; margin-right: 5px;"></i>{{ trackArray?.truckOwnerInfo?.mobile || trackArray?.truckownerDetails?.mobile }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="myModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title trip" style="color: #f58634; font-weight: 500; font-size: 1.5rem;">{{ trackArray?.trip_id }}</h4>
        <button
          type="button"
          (click)="closeModel()"
          class="close"
          data-dismiss="modal"
          style="border: none; background: transparent; font-size: 1.5rem; color: #555;"
        >
          &times;
        </button>
      </div>
      <div class="modal-body">
        <div class="row" style="margin-bottom: 10px;">
          <div class="col-md-6">
            <div class="name" style="font-weight: bold; font-size: 1rem; color: #444; margin-bottom: 5px;">Trip Date</div>
            <div style="font-size: 0.95rem; color: #555;">{{ trackArray?.trip_start | date : "dd-MM-yyyy" }}</div>
          </div>
          <div class="col-md-6">
            <div class="name" style="font-weight: bold; font-size: 1rem; color: #444; margin-bottom: 5px;">Driver Name:</div>
            <div style="font-size: 0.95rem; color: #555;">{{ trackArray?.driverInfo?.username || trackArray?.driverDetails?.username }}</div>
          </div>
        </div>
        <div class="row" style="margin-bottom: 10px;">
          <div class="col-md-6">
            <div class="name" style="font-weight: bold; font-size: 1rem; color: #444; margin-bottom: 5px;">Driver Number:</div>
            <div style="font-size: 0.95rem; color: #555;">{{ trackArray?.driverInfo?.mobile || trackArray?.driverDetails?.mobile }}</div>
          </div>
          <div class="col-md-6">
            <div class="name" style="font-weight: bold; font-size: 1rem; color: #444; margin-bottom: 5px;">Truck Number:</div>
            <div style="font-size: 0.95rem; color: #555;">{{ trackArray?.truckInfo?.truck_number || data?.vehicleNumber }}</div>
          </div>
        </div>
        <div class="row" style="margin-bottom: 10px;">
          <div class="col-md-6">
            <div class="name" style="font-weight: bold; font-size: 1rem; color: #444; margin-bottom: 5px;">Lat:</div>
            <div style="font-size: 0.95rem; color: #555;">{{ data?.latitude }}</div>
          </div>
          <div class="col-md-6">
            <div class="name" style="font-weight: bold; font-size: 1rem; color: #444; margin-bottom: 5px;">Long:</div>
            <div style="font-size: 0.95rem; color: #555;">{{ data?.longitude }}</div>
          </div>
        </div>
        <div class="row" style="margin-bottom: 10px;">
          <div class="col-md-12">
            <div class="name" style="font-weight: bold; font-size: 1rem; color: #444; margin-bottom: 5px;">Last Updated</div>
            <div style="font-size: 0.95rem; color: #555;">{{ (data?.endTrackDateTime || data?.trackDateTime) ? ((data?.endTrackDateTime || data?.trackDateTime) | date : "dd MMMM yyyy, hh:mm:ss a") : '--' }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="name" style="font-weight: bold; font-size: 1rem; color: #444; margin-bottom: 5px;">Location</div>
            <div style="font-size: 0.95rem; color: #555; line-height: 1.5;">{{ data?.address }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
